import {
  loadMentionMeForPurchase,
} from "apps/website/utils/load-mention-me-for-purchase";

import { PostCheckoutMentionMeTrigger, TriggerHandler } from "../types";

export const mentionMeHandler: TriggerHandler<PostCheckoutMentionMeTrigger> = (
  _,
  context,
  trigger,
) => {
  const data = context.sources?.firstOrder;

  if (!data) {
    return false;
  }

  const katkinCustomerId = context.query.get("katkinCustomerId");

  if (!katkinCustomerId) {
    return false;
  }

  const { firstCharge } = data;

  loadMentionMeForPurchase(
    firstCharge,
    katkinCustomerId,
    trigger.enablePopup,
  );

  return true;
};
